<template>
  <vuescroll>
    <div class="box-border m-8">
      <Header>
        <template v-slot:title>Portafolio</template>
        <template v-slot:subtitle>Mi mejor trabajo?</template>
      </Header>
      <div class="text-6xl text-center">
        Work in progress
      </div>
      <div class="mb-4 text-3xl text-center">
        Creando un portafolio público ya que todos mis trabajos pertenecen a
        empresas. Puedes comenzar viendo este sitio realizado con Vue,
        Vue-Router, TailwindCSS, HTML5 y CSS3
      </div>
      <button class="px-8 py-1 mb-3 mr-3 font-semibold uppercase border border-t-2 border-b-2 border-l-2 border-r-2 rounded-full focus:outline-none hover:bg-tertiary hover:text-white" :class="[filter === 'all' ? 'bg-tertiary text-white' : 'text-primary bg-background-menu']" @click="filter = 'all'">Todos</button>
      <button v-for="(category, index) in categories" :key="index" class="px-8 py-1 mb-3 mr-3 font-semibold uppercase border border-t-2 border-b-2 border-l-2 border-r-2 rounded-full focus:outline-none hover:bg-tertiary hover:text-white" :class="[filter === category ? 'bg-tertiary text-white' : 'text-primary bg-background-menu']" @click="filter = category">{{ category }}</button>        
      <div class="grid grid-cols-1 gap-4 mt-8 lg:gap-8 lg:grid-cols-2">
        <Projects
          v-for="(project, index) in filteredProjects"
          :key="index"
          :data.sync="project"
        />
      </div>
    </div>
  </vuescroll>
</template>

<script>
import vuescroll from "vuescroll";
import Header from "../components/Header";
import Projects from "../components/Projects";
import data from "../data/projects";

export default {
  name: "Portfolio",
  components: {
    Header,
    vuescroll,
    Projects,
  },
  data() {
    return {
      data: data,
      filter: "all",
    };
  },
  methods: {
    pluck(array) {
      return array.map((obj) => obj.categories.map((categories) => categories));
    },
  },
  computed: {
    categories() {
      return [...new Set(this.pluck(this.data).flat())];
    },
    filteredProjects() {
      if (this.filter === "all") return this.data;
      return [...data].filter((obj) => obj.categories.includes(this.filter));
    },
  },
};
</script>
